import type { Resource } from '../../';
export const product_details_style: Resource = {"default":"Sneaker Style"};
